import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, TextField, InputAdornment, IconButton } from "@mui/material";
import { useState } from "react";

const PasswordField = ({
  name,
  placeholder,
  formik,
  values,
  onChange,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "start",
        gap: "0.5em",
      }}
    >
      <TextField
        {...props}
        size="small"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <img
                src="./images/lock.svg"
                alt={name}
                style={{ width: "20px", height: "20px" }}
              />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
        fullWidth
        id={name}
        name={name}
        value={formik?.values[name] || values || ""}
        onChange={onChange || formik?.handleChange}
        error={(formik?.touched[name] && Boolean(formik?.errors[name])) || ""}
        helperText={formik.touched[name] && formik.errors[name]}
        placeholder={placeholder}
        sx={{
          "& input": {
            fontFamily: "Lato",
            fontWeight: "700",
          },
        }}
        type={showPassword ? "text" : "password"}
      />
    </Box>
  );
};

export default PasswordField;
